import { Bot, ShieldAlert, ShieldCheck } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';
import { useBotInfo } from '@/lib/hooks/useBotInfo';

/**
 * Real bot identity/status via the Bridge (dembot/docs/BOT_BRIDGE.md) —
 * shared by the dashboard Overview and the public Status page so this
 * isn't maintained as two near-identical copies.
 */
export function BotStatusCard() {
  const botInfo = useBotInfo();

  return (
    <Card>
      <CardHeader
        title="Bot status"
        description="Real data from the Bot Bridge — never fabricated."
        action={<Bot size={18} className="text-text-tertiary" aria-hidden="true" />}
      />
      {botInfo.status === 'loading' ? (
        <div className="space-y-2">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-5 w-24" />
        </div>
      ) : null}
      {botInfo.status === 'error' ? (
        <p className="text-small text-text-secondary">
          {botInfo.error.code === 'BOT_UNREACHABLE'
            ? 'The Bot Bridge is not configured or not reachable right now.'
            : botInfo.error.message}
        </p>
      ) : null}
      {botInfo.status === 'success' ? (
        <div className="flex items-center gap-4 text-small text-text-secondary flex-wrap">
          <span>{botInfo.data.username}</span>
          <span>v{botInfo.data.version}</span>
          <span>{botInfo.data.guildCount} servers</span>
          <span className="inline-flex items-center gap-1">
            {botInfo.data.degraded ? (
              <>
                <ShieldAlert size={14} className="text-warning" aria-hidden="true" /> Degraded
              </>
            ) : (
              <>
                <ShieldCheck size={14} className="text-success" aria-hidden="true" /> Healthy
              </>
            )}
          </span>
        </div>
      ) : null}
    </Card>
  );
}
